import { Injectable } from '@angular/core';
import {Message} from '../../shared/models/message';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  public message = new Message();
  public messageSubject = new Subject<Message>();
  public messageObservable = this.messageSubject.asObservable();
  constructor() { }

  /**
   *
   * @param message
   */
  pushInfo(message: string) {
    this.messageSubject.next({
      type: 'info',
      message
    });
  }

  /**
   *
   * @param message
   */
  pushError(message: string) {
    this.messageSubject.next({
      type: 'error',
      message
    });
  }
}
